import { BASE_CDN_URL, BASE_CDN_URL_DEV, BASE_CDN_URL_STAGE, BASE_CDN_URL_UAT, IMAGES_CDN_URL } from '../../disw-utils/src/constants/api_urls.js';
// DISW CDN URL
export const CDN_URL = `${BASE_CDN_URL}/disw`;
// Contentful Data API URL
export const CONTENTFUL_DATA_API_URL = `${BASE_CDN_URL}/api/`;
export const CONTENTFUL_DATA_API_URL_DEV = `${BASE_CDN_URL_DEV}/api/`;
export const CONTENTFUL_DATA_API_URL_STAGE = `${BASE_CDN_URL_STAGE}/api/`;
export const CONTENTFUL_DATA_API_URL_UAT = `${BASE_CDN_URL_UAT}/api/`;
export const CONTENTFUL_DATA_API_URL_XD = `${BASE_CDN_URL}/disw/`;
export const CONTENTFUL_DATA_API_URL_XD_DEV = `${BASE_CDN_URL_DEV}/disw/`;
export const CONTENTFUL_DATA_API_URL_XD_STAGE = `${BASE_CDN_URL_STAGE}/disw/`;
export const CONTENTFUL_DATA_API_URL_XD_UAT = `${BASE_CDN_URL_UAT}/disw/`;
export const DISW_LOGIN = 'disw-profile-signin';
export const SAAS_CATEGORY = 'SAAS';
export const EXTERNAL_CATEGORY = 'External';
export const LOCALNAV_CONTEXT_ID = 'lnc';
// Contact Sales
export const CONTACT_SALES_STRING = 'contact sales';
export const COMMERCE_BTN = 'commerce';
export const MILLISECONDS_PER_SECOND = 1000;
// OneTrust Cookie Category (marketing cookies AKA targeting cookies)
export const COOKIE_CATEGORY_TARGETING = 'targ';
// Grouped header items per column
export const MAX_ITEMS_PER_COLUMN = 8;
// Truncation Lengths
export const TEXT_MAX_LENGTH = 55;
// Key to get checkoutLocalData from localStorage
export const CHECKOUT_LOCAL_DATA_KEY = 'checkout-local-data';
// Timeout to reset checkoutLocalData
export const CHECKOUT_LOCAL_TIMEOUT_IN_MINUTES = 10;
export const CHECKOUT_LOCAL_TIMEOUT_DURATION = 1000 * 60 * CHECKOUT_LOCAL_TIMEOUT_IN_MINUTES;
// URL to update personal information (My Account Screen)
export const UPDATE_PERSONAL_INFO_URL = process.env.UNIVERSAL_COMPONENTS_ENV == 'prod' ? 'https://sp.login.siemens.com/profile' : 'https://sp.login-qa.siemens.com/profile';
// Images CDN URL
export const IMAGES_URL = `${IMAGES_CDN_URL}/siemens-disw-assets/public/`;
